module.exports = __webpack_public_path__ + "static/media/1017114.6e039f7a.png";